import React from 'react';
import { useAppSelector } from "../../../utils/Hooks";
import { calculateProjectedAnnualGoalPercentage } from "../PerformanceProjection";

interface TotalsProps {
    week: number;
}

const Totals: React.FC<TotalsProps> = ({ week }) => {
    const performanceData = useAppSelector(state => state.performanceIndicators);

    const timePercentage = parseFloat((performanceData?.total?.total?.percentage_of_year_passed || 0).toFixed(1));
    const yearlyGoalPercentage = parseFloat((performanceData?.total?.total?.goal_percentage_year || 0).toFixed(1));
    const projectedYearlyGoalPercentage = calculateProjectedAnnualGoalPercentage(yearlyGoalPercentage, timePercentage);
    const totalProfit = parseFloat((performanceData?.total?.total?.profit_this_year || 0).toFixed(2));
    const weeklyGoalPercentage = parseFloat((performanceData?.total?.total?.total_profit_goal_percentage || 0).toFixed(1));
    const weeklyProfit = parseFloat((performanceData?.total?.total?.total_profit_difference || 0).toFixed(2));

    const yearlyGoalComparison = yearlyGoalPercentage >= timePercentage ? '#ccffcc' : '#ffcccc';
    const weeklyGoalComparison = weeklyGoalPercentage >= 100 ? '#ccffcc' : '#ffcccc';

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Nädala seis</th>
                    <th>% ETS W goalist</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{weeklyProfit}</td>
                    <td style={{ backgroundColor: weeklyGoalComparison }}>
                        {weeklyGoalPercentage}%
                    </td>
                </tr>
                </tbody>
            </table>

            <table className="data">
                <thead>
                <tr>
                    <th>Aastast möödunud</th>
                    <th>Protsent aasta eesmärgist</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{timePercentage}%</td>
                    <td style={{ backgroundColor: yearlyGoalComparison }}>
                        {yearlyGoalPercentage}%
                    </td>
                </tr>
                <tr>
                    <td>Prognoositav aastaeesmärgi täituvus</td>
                    <td>
                        {projectedYearlyGoalPercentage}%
                    </td>
                </tr>
                </tbody>
            </table>
        </>
    );
};

export default Totals;
